import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { DISABLE_ALL_ANIMATIONS } from '@bubble-dev/build-config';
var DottedKeyframeId = 'klarna-loader-animation-dotted';
export var getLoaderSize = _ref => {
  var {
    small,
    large,
    UNSAFE_size
  } = _ref;
  if (UNSAFE_size !== undefined) {
    return UNSAFE_size;
  }
  var sizeName = small && 'small' || large && 'large' || 'default';
  return loaderSizes[sizeName];
};
var loaderSizes = {
  small: 12,
  large: 100,
  default: 20
};
export var getKeyframes = () => "\n    @keyframes ".concat(DottedKeyframeId, " {\n      0%, 100% { transform: translateY(0); }\n      50% { transform: translateY(-10%); }\n    }\n  ").replace(/ {2}|\n/g, '');
export var getDefaultStyleSheet = _ref2 => {
  var {
    designContext,
    disableAnimations,
    inverted,
    large,
    small,
    UNSAFE_colorToken,
    UNSAFE_colorTokenArgs,
    UNSAFE_size
  } = _ref2;
  var outerDiameter = getLoaderSize({
    large,
    small,
    UNSAFE_size
  });
  var outerRadius = outerDiameter / 2;
  var bulletSize = outerDiameter / 100 * 23 / 2;
  return {
    svgAttrs: {
      viewBox: "0 0 ".concat(outerDiameter, " ").concat(outerDiameter)
    },
    svgStyle: {
      width: outerDiameter,
      height: outerDiameter
    },
    circleAttrs: i => ({
      cx: i === 0 ? bulletSize : i === 1 ? outerRadius : outerDiameter - bulletSize,
      cy: outerRadius,
      r: bulletSize
    }),
    circleStyle: i => _objectSpread({
      fill: UNSAFE_colorToken ? designContext.get(UNSAFE_colorToken, UNSAFE_colorTokenArgs).toString() : inverted ? designContext.get('colors/backgrounds/default').toString() : designContext.get('colors/backgrounds/inverse').toString()
    }, disableAnimations || DISABLE_ALL_ANIMATIONS ? null : {
      animation: "".concat(DottedKeyframeId, " 0.8s infinite ease-in-out"),
      animationDelay: "".concat(i * 0.2, "s")
    })
  };
};
//# sourceMappingURL=utils.js.map